import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-statistic-icon',
  templateUrl: './statistic.svg',
  styleUrls: ['./statistic-icon.component.scss'],
})
export class StatisticIconComponent {
  @Input() fillColor = '#808080';
}
